class OneOffPaymentMethods {
    static StripeDirectDebitCollection: string = "Stripe Direct Debit Collection";
    static DirectBankTransfer: string = "Direct Bank Transfer"
}

export { OneOffPaymentMethods }
